<template>
    <b-form-radio :value="value">
        <span>
            en tant que <strong>professionnel indépendant</strong> ou <strong>étudiant</strong>
        </span>

        <span class="cursus-radios__help">
            (auto-entrepreneur / auteur-réalisateur / artiste / demandeur d’emploi / intermittent / ...)
        </span>
    </b-form-radio>
</template>

<script>
    /**
     * used in AccountForm too
     */
    export default {
        props: {
            value: null,
        }
    }
</script>
